import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';
import { StringLengthRule } from 'devextreme-react/validator';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class FileTypesGrid extends Component {
    state = {
    };

    resize = () => {
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
        e.data.productive = true;
        e.data.active = true;
    }

    onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid 
            dataSource={apis.FileTypesDataSource(this.props.user.access_token)}  
            noDataText="There are no file types defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'fileTypes' }}
            height={getHeight }
            width="100%" ref={(gv) => {this.gridview = gv}} 
            onInitNewRow={this.setDefaultNewValues} onToolbarPreparing={this.onToolbarPreparing}
         >
         <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminFileTypes}
            allowDeleting={this.props.grants.rights.adminFileTypes}
            allowAdding={this.props.grants.rights.adminFileTypes} >
             <Popup title={'File Types'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'description'}>
            <RequiredRule />
            <StringLengthRule max="100" message="The file type description cannot exceed 100 characters."/>
        </Column>
        <Column dataField={'active'} />
 
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
  return {
      user: state.oidc.user,
      grants: state.rights
  };
}


export default connect(mapStateToProps, null)(FileTypesGrid)